import { withFormElement } from "@brynlabs/webforms-react"
import PropTypes from "prop-types"
import React from "react"

const WebformsAdditionalData = withFormElement(
  ({ setData, additionalData }) => {
    setData(additionalData)
    return <></>
  },
)

WebformsAdditionalData.propTypes = {
  additionalData: PropTypes.any.isRequired,
}

export { WebformsAdditionalData }
